import { TagCloud } from "@/components/internal/TagCloud";
import { UseMutationResult } from "@tanstack/react-query";
import { TagPreferenceType } from "@/lib/supabase";

interface FilterComponentProps {
  tagPreferences: {
    included: string[];
    excluded: string[];
  };
  updateTagPreference: UseMutationResult<
    void,
    Error,
    { tagName: string; preferenceType: TagPreferenceType | null }
  >;
  isLargeScreen: boolean;
}

export const FilterComponent = ({
  tagPreferences,
  updateTagPreference,
  isLargeScreen,
}: FilterComponentProps) => {
  return (
    <div className="lg:sticky lg:top-[4.5rem] lg:rounded-lg lg:bg-background dark:lg:bg-background lg:space-y-2 lg:max-h-[calc(100vh-5rem)] lg:overflow-y-auto lg:[&::-webkit-scrollbar]:hidden lg:[-ms-overflow-style:none] lg:[scrollbar-width:none]">
      <TagCloud
        includedTags={tagPreferences.included}
        excludedTags={tagPreferences.excluded}
        updateTagPreference={updateTagPreference}
        isLargeScreen={isLargeScreen}
      />
    </div>
  );
};
